export default __webpack_public_path__ + "static/media/U Bank Cheque.b342a934.jpg";